import { render, staticRenderFns } from "./SourcesBadgeList.vue?vue&type=template&id=bcb7052a&scoped=true&"
import script from "./SourcesBadgeList.vue?vue&type=script&lang=js&"
export * from "./SourcesBadgeList.vue?vue&type=script&lang=js&"
import style0 from "./SourcesBadgeList.vue?vue&type=style&index=0&id=bcb7052a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb7052a",
  null
  
)

export default component.exports